import { sdk } from 'src/utilities/sdk';
import { IEmployee } from 'src/components/ManageEnterpriseEmployeeModal/ManageEnterpriseEmployeeModal';

export async function editParentAdmin(
  corpId: string,
  dinerId: string,
  employeeInfo: Pick<
    IEmployee,
    | 'first_name'
    | 'last_name'
    | 'email'
    | 'phone_number'
    | 'internal_id'
    | 'role'
    | 'corp_diner_settings'
  >
): Promise<void> {
  await sdk.http.put(`/corp-admin/${corpId}/diners/${dinerId}`, {
    ...employeeInfo,
    id: dinerId,
  });
}
